PolylineLayer = require './polyline-layer'

module.exports = App.PolygonLayerComponent = PolylineLayer.extend
  createLayer: ->
    @L.polygon.apply @L, @get('requiredOptions').concat([ @get('options') ])